// @flow
import localizedStrings from 'util/localizedStrings';
import { type CertInfo } from 'state/types';

export function getCertStatusText(info: ?CertInfo) {
  if (!info || !info.issuer || !info.owner || !info.endDate) {
    return localizedStrings.CERTIFICATE_STATUS_INVALID;
  }
  if (info.issuer.indexOf('127.0.0.1') >= 0) {
    return localizedStrings.CERTIFICATE_STATUS_SELF_SIGNED;
  }

  if (isCertExpired(info)) {
    return localizedStrings.CERTIFICATE_STATUS_EXPIRED;
  }
  return localizedStrings.CERTIFICATE_STATUS_IMPORTED;
}

export function isCertExpired(info: ?CertInfo): boolean {
  if (!info || !info.endDate) {
    return false;
  }
  var endDate: Date = new Date(info.endDate);
  return endDate.getTime() < new Date().getTime();
}

export function getCertStatusStyle(info: ?CertInfo): string {
  var status = getCertStatusText(info);
  if (status === localizedStrings.CERTIFICATE_STATUS_SELF_SIGNED) {
    return 'has-text-danger';
  } else if (
    status === localizedStrings.CERTIFICATE_STATUS_INVALID ||
    status === localizedStrings.CERTIFICATE_STATUS_EXPIRED
  ) {
    return 'has-text-danger';
  }
  return '';
}

// Create a list of SANs from a comma-delimited string, trim whitespace, and add the FQDN if needed
export function normalizeSANs(cdList: string, fqdn: string): string[] {
  if (!cdList) {
    cdList = '';
  }
  const stringArray = cdList.split(',');
  const saNames = [];
  const removeWhiteSpaceRegExp: RegExp = /\s+/g;
  let includesFqdn = false;

  stringArray.forEach(name => {
    name = name.replace(removeWhiteSpaceRegExp, '');
    if (name) {
      if (fqdn && name === fqdn) {
        includesFqdn = true;
      }
      saNames.push(name);
    }
  });

  if (!includesFqdn && fqdn) {
    saNames.push(fqdn);
  }
  return saNames;
}



// WEBPACK FOOTER //
// ./src/util/certUtils.js